export default __webpack_public_path__ + "static/media/MoviesPort.17234825.png";